import { useState, useEffect, useRef } from "react";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import $ from "jquery";
import validEmail from "../../utils/emailUtils";

function formatPhoneNumber(value) {
  if (!value) return "";
  const phoneNumber = value.replace(/[^\d]/g, "");
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6, 10)}`;
}
let obj = {
  contactEmail: "",
  phone: "",
  tfaOn: false,
};
const TwoFactor = () => {
  const { userToken, SetSharedObject, sharedObject } = useUserStore(
    (state) => ({
      userToken: state.userToken,
      SetSharedObject: state.SetSharedObject,
      sharedObject: state.sharedObject,
    })
  );
  const [flag, setFlag] = useState(false);
  const [flagSuccess, setFlagSuccess] = useState(false);
  const [errCreateMsg, SetErrCreateMsg] = useState(false);
  const [errMsg, SetErrMsg] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [answers, setAnswers] = useState(obj);
  const [errEmail, SetErrEmail] = useState(false);
  const setAnswer = async (questionId, answer) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };
  const SetObject = async (ob) => {
    await setAnswers({
      ...answers,
      contactEmail: ob.tfaEmail,
      phone: formatPhoneNumber(ob.tfaPhone),
      tfaOn: ob.tfaOn,
    });
    setFlagSuccess(false);
  };
  useEffect(() => {
    if (sharedObject.TwoFactorObject) SetObject(sharedObject.TwoFactorObject);
    SetErrCreateMsg(false);
  }, [sharedObject.TwoFactorObject]);
  const SubmitForm = async () => {
    SetErrEmail(false);
    setFlag(false);
    SetErrCreateMsg(false);
    SetErrMsg(false);
    setFlagSuccess(false);
    if (answers.contactEmail || answers.phone) {
      if (
        !isEmpty(answers.contactEmail) &&
        !validEmail(answers.contactEmail)
      ) {
        SetErrEmail(true);
        return;
      }
      let call = `/users/UpdateTwoFactor?tfaPhone=${
        answers.phone ? answers.phone : ""
      }&tfaEmail=${answers.contactEmail ? answers.contactEmail : ""}&tfaOn=${
        answers.tfaOn
      }&userId=${
        sharedObject.TwoFactorObject.id ? sharedObject.TwoFactorObject.id : -1
      }`;
      setProcessing(true);
      const res = await CallAPI(call, false, "get", userToken);
      await SetSharedObject("ResponseCode", res.code);
      if (res.status === "SUCCESS") {
        setProcessing(false);
        setFlagSuccess(true);
        SetSharedObject("reloadEmailList", true);
        CloseTwoFactorSettingModal();
      } else if (res.status === "SERVERERROR") {
        let msg = res.data;
        let str = "<div>";
        for (let el of msg) {
          str += `${el}`;
        }
        str += "</div>";
        SetErrMsg(str);
        SetErrCreateMsg(true);
        setProcessing(false);
      }
    } else {
      setFlag(true);
      return;
    }
  };

  const changeTFA = () => {
    if (answers.tfaOn === true) {
      setAnswer("tfaOn", false);
    } else {
      setAnswer("tfaOn", true);
    }
  };

  const setPhone = async (val) => {
    if (val !== "") {
      setAnswer("phone", val);
    } else {
      setAnswer("phone", null);
    }
  };
  const setEmail = async (val) => {
    if (val !== "NotProvided") {
      setAnswer("contactEmail", val);
    } else {
      setAnswer("contactEmail", null);
    }
  };
  function formatContactEmail(val) {
    if (val === "NotProvided") {
      return "";
    } else {
      return val;
    }
  }
  function isEmpty(value) {
    let x =
      value == null || (typeof value === "string" && value.trim().length === 0);
    return x;
  }
  const modalRef = useRef(null);
  const closeBtnRef = useRef(null);

  // Focus modal when opened
  useEffect(() => {
    if (sharedObject.TwoFactorObject && modalRef.current) {
      modalRef.current.focus();
    }
  }, [sharedObject.TwoFactorObject]);

  // Keyboard support for Esc to close modal
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        CloseTwoFactorSettingModal();
      }
    };
    if (modalRef.current) {
      modalRef.current.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      if (modalRef.current) {
        modalRef.current.removeEventListener("keydown", handleKeyDown);
      }
    };
  }, []);
    const closeModal = (modalId) => {
    if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
    }

        $(`#${modalId}`).modal('hide');
    };

    const CloseTwoFactorSettingModal = () => closeModal('TwoFactorSettingModal');

  return (
    <div className="TwoFactor">
      <div
        className="modal fade"
        id="TwoFactorSettingModal"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        aria-labelledby="TwoFactorModalTitle"
        aria-describedby="TwoFactorModalDesc"
        data-backdrop="static"
        ref={modalRef}
        style={{ outline: "none" }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="TwoFactorModalTitle">
                Two-Factor Setting
              </h3>
              <button
                type="button"
                className="close"
                onClick={CloseTwoFactorSettingModal}
                aria-label="Close dialog"
                ref={closeBtnRef}
                disabled={processing}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" id="TwoFactorModalDesc">
              {flagSuccess ? (
                <>
                  <div className="bi-success-check" aria-hidden="true">
                    <i className="bi bi-check2-circle"></i>
                  </div>
                  <div className="message-wrapper" aria-live="polite">
                    Two-Factor Authentication has been saved successfully.
                  </div>
                </>
              ) : (
                <>
                  <div className="descript-container">
                    Two-factor authentication is an enhanced security measure.
                    Once enabled, users will be prompted for additional authentication code.
                  </div>
                  <div className="field-wrapper modal-content-form">
                    <label htmlFor="tfa-phone">Code Sent by Text Message</label>
                    <div>
                      <input
                        type="text"
                        id="tfa-phone"
                        name="Phone"
                        className="form-control"
                        onChange={(el) => setPhone(el.target.value)}
                        value={formatPhoneNumber(answers.phone)}
                        aria-describedby="tfa-phone-desc"
                        inputMode="tel"
                        autoComplete="tel"
                      />
                      <span id="tfa-phone-desc" className="sr-only">Enter your phone number to receive two-factor authentication codes via text message.</span>
                    </div>
                  </div>
                  <div className="field-wrapper modal-content-form">
                    <label htmlFor="tfa-email" id="tfa-email-label">Code Sent by Email</label>
                    <div>
                      <input
                        type="email"
                        id="tfa-email"
                        name="ContactEmail"
                        className="form-control"
                        value={formatContactEmail(answers.contactEmail)}
                        onChange={(el) => setEmail(el.target.value)}
                        autoComplete="email"
                        aria-describedby={
                            errEmail
                                ? "tfa-email-error"
                                : "tfa-email-hint"
                        }
                      />
                    </div>
                    <div
                      className="descript2-container line-s1 sp-margin3"
                      id="tfa-email-hint"
                    >
                      Email will be used if mobile number is not available.
                    </div>
                  </div>
                  {flag ? (
                    <div
                      className="alert alert-danger field-wrapper modal-content-form"
                      id="tfa-error"
                      role="alert"
                      aria-live="assertive"
                      aria-atomic="true"
                    >
                      Either Contact Email or Phone Number is required.
                    </div>
                  ) : null}
                  <div className="field-wrapper modal-content-form">
                    <label htmlFor="tfa-toggle" id="tfa-toggle-label">Turn On:</label>
                    <button
                      type="button"
                      className={`btn btn-link sp-pad0 v-set3 ${answers.tfaOn ? "bi bi-shield-fill-check" : "bi bi-shield-slash gray"}`}
                      aria-pressed={answers.tfaOn}
                      aria-label={
                        answers.tfaOn
                          ? "Disable Two-Factor Authentication"
                          : "Enable Two-Factor Authentication"
                      }
                      title={
                        answers.tfaOn
                          ? "Two-Factor Authentication Enabled"
                          : "Two-Factor Authentication Disabled"
                      }
                      onClick={(el) => {
                        changeTFA();
                        el.preventDefault();
                      }}
                      aria-labelledby="tfa-toggle-label"
                    >
                      <span className="sr-only">
                        {answers.tfaOn
                          ? "Two-Factor Authentication Enabled"
                          : "Two-Factor Authentication Disabled"}
                      </span>
                    </button>
                  </div>
                </>
              )}

              {errCreateMsg ? (
                <div
                  className="alert alert-danger"
                  role="alert"
                  aria-live="assertive"
                  aria-atomic="true"
                  dangerouslySetInnerHTML={{ __html: errMsg }}
                />
              ) : null}
              {errEmail ? (
                <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                  Please enter a valid email name with more than 4 characters
                  long, no spaces, commas, or special characters.
                </div>
              ) : null}
            </div>
            <div className="modal-footer">
              {flagSuccess ? (
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={CloseTwoFactorSettingModal}
                >
                  Close
                </button>
              ) : (
                <>
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={() => SubmitForm()}
                    disabled={processing}
                  >
                    {processing ? "Saving..." : "Save"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={CloseTwoFactorSettingModal}
                    disabled={processing}
                  >
                    Cancel
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwoFactor;
